import { createSlice } from '@reduxjs/toolkit';

const initialState = {

}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {

    }
})

export default appSlice.reducer
export const { } = appSlice.actions
